__turbopack_context__.v({
  "caption": "modal-collection-viewer-module-scss-module__IzAVPa__caption",
  "downloadIcon": "modal-collection-viewer-module-scss-module__IzAVPa__downloadIcon",
  "image": "modal-collection-viewer-module-scss-module__IzAVPa__image",
  "imageContainer": "modal-collection-viewer-module-scss-module__IzAVPa__imageContainer",
  "imageContentContainer": "modal-collection-viewer-module-scss-module__IzAVPa__imageContentContainer",
  "inactive": "modal-collection-viewer-module-scss-module__IzAVPa__inactive",
  "loading": "modal-collection-viewer-module-scss-module__IzAVPa__loading",
  "loadingIcon": "modal-collection-viewer-module-scss-module__IzAVPa__loadingIcon",
  "restricted": "modal-collection-viewer-module-scss-module__IzAVPa__restricted",
  "rightsMessage": "modal-collection-viewer-module-scss-module__IzAVPa__rightsMessage",
});
